module.exports = __webpack_public_path__ + "img/reviersport.be68045f.png";